function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "youtube",
  fill: "#3A4164",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.428571,0 C22.848214,0 24,1.151786 24,2.571429 L24,21.428571 C24,22.848214 22.848214,24 21.428571,24 L2.571429,24 C1.151786,24 0,22.848214 0,21.428571 L0,2.571429 C0,1.151786 1.151786,0 2.571429,0 L21.428571,0 Z M20.1447689,7.87759331 C19.9492544,7.13853151 19.3732017,6.55646873 18.6417895,6.35893718 C17.3160522,6 12,6 12,6 C12,6 6.68397845,6 5.3582105,6.35893718 C4.62679825,6.5565003 4.0507456,7.13853151 3.85523115,7.87759331 C3.5,9.21718746 3.5,12.0121246 3.5,12.0121246 C3.5,12.0121246 3.5,14.8070626 3.85523115,16.1466559 C4.0507456,16.8857185 4.62679825,17.4435313 5.3582105,17.641062 C6.68397845,18 12,18 12,18 C12,18 17.3160215,18 18.6417895,17.641062 C19.3732017,17.4435313 19.9492544,16.8857185 20.1447689,16.1466559 C20.5,14.8070626 20.5,12.0121246 20.5,12.0121246 C20.5,12.0121246 20.5,9.21718746 20.1447689,7.87759331 Z M10.5,15 L10.5,9 L14.5,12.0000747 L10.5,15 Z"
})));

function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4c360a21.svg";
export { ForwardRef as ReactComponent };